
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'SolidTumor',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/SolidTumor.vue